import i18n from '../../../../i18n/config';

import type { InvalidPromoErrorReason } from './types';

export const getInvalidPromoCodeToMsgMap = (): Record<InvalidPromoErrorReason, string> => ({
  PromoCodeInactiveError: i18n.t('promoCode.errors.inactive'),
  PromoCodeExpiredError: i18n.t('promoCode.errors.expired'),
  PromoCodeAlreadyUsedByUserError: i18n.t('promoCode.errors.alreadyUsed'),
  PromoCodeReachedTotalLimitError: i18n.t('promoCode.errors.limitReached'),
  PromoCodeNotExistsError: i18n.t('promoCode.errors.notExists'),
  InternalServerErrorType: i18n.t('promoCode.errors.technicalError'),
  PromoCodeNotApplicableError: i18n.t('promoCode.errors.notApplicable'),
});
